<div class="flex flex-col items-center py-10">
  <img src="/assets/svg/no-data.svg" alt="" width="200" />
  <p class="text-secondary-muted mt-5">{{ message() }}</p>
</div>
